import React from "react";

function ReporteCamion({ datos }) {
  if (!datos) return <p>No hay reporte para mostrar.</p>;

  return (
    <div style={containerStyle}>
      {/* Encabezado empresa */}
      <div style={encabezadoStyle}>
        <img src="/movimonte-logo.png" alt="Logo" style={logoStyle} />
        <div style={infoEmpresaStyle}>
          <h2 style={tituloEmpresa}>MOVIMONTE SPA</h2>
          <p style={textoSub}>Transporte de carga, movimiento de tierra y compra y venta de áridos</p>
          <p style={textoNormal}>📍 Domingo Santa María #191, El Monte</p>
          <p style={textoNormal}>✉️ andre_323@live.com | ventas@movimonte.com</p>
          <p style={textoNormal}>
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
              alt="WhatsApp"
              style={{ width: "14px", verticalAlign: "middle", marginRight: "6px" }}
            />
            +56957020163 - +56968311079
          </p>
        </div>
      </div>

      {/* Caja con Fecha + N° */}
      <div style={fechaCajaStyle}>
        <div style={fechaBox}><strong>DÍA:</strong> {datos.fecha?.dia || "____"}</div>
        <div style={fechaBox}><strong>MES:</strong> {datos.fecha?.mes || "____"}</div>
        <div style={fechaBox}><strong>AÑO:</strong> {datos.fecha?.año || "____"}</div>
        <div style={fechaBox}><strong>N°:</strong> {datos.numero || "____"}</div>
      </div>

      {/* CAMIÓN y PATENTE */}
      <div style={camionPatenteStyle}>
        <div style={campoCamion}>
          <strong>CAMIÓN:</strong> <span style={lineaCamion}>{datos.maquina || ""}</span>
        </div>
        <div>
          <strong>PATENTE:</strong> <span style={lineaFaena}>{datos.patente || ""}</span>
        </div>
      </div>

      {/* Tabla de kilometrajes */}
      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={headerCellStyle}>KM u HR. FINAL</th>
            <th style={headerCellStyle}>KM u HR. INICIAL</th>
            <th style={headerCellStyle}>KM u HR. DÍA</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={cellStyle}>{datos.kmFinal || ""}</td>
            <td style={cellStyle}>{datos.kmInicial || ""}</td>
            <td style={cellStyle}>
              {datos.kmFinal && datos.kmInicial ? Number(datos.kmFinal) - Number(datos.kmInicial) : ""}
            </td>
          </tr>
        </tbody>
      </table>

      {/* Actividades */}
      <div style={actividadBoxStyle}>
        {[1, 2, 3, 4, 5, 6].map((num) => (
          <div key={num} style={lineaActividad}>
            {num}. ________________________________________________________________________________
          </div>
        ))}
      </div>

      {/* FAENA */}
      <div style={sectionTitleBox}>
  <div style={sectionTitleStyle}>FAENA</div>
  <div style={lineaHorizontal}></div>
</div>

      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={headerCellStyle}>PETRÓLEO Lts.</th>
            <th style={headerCellStyle}>GASOLINA Lts.</th>
            <th style={headerCellStyle}>ACEITE Lts.</th>
            <th style={headerCellStyle}>GRASA</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={cellStyle}>{getFaena("PETROLEO")}</td>
            <td style={cellStyle}>{getFaena("GASOLINA")}</td>
            <td style={cellStyle}>{getFaena("ACEITE")}</td>
            <td style={cellStyle}>{getFaena("GRASA")}</td>
          </tr>
        </tbody>
      </table>

      {/* OBSERVACIONES */}
      <div style={sectionTitleStyle}>OBSERVACIONES</div>
      <div style={lineaObservacion}>{datos.observaciones || ""}</div>

      {/* FIRMAS */}
      <div style={firmasStyle}>
        <div style={firmaBox}>
          <div style={firmaLinea}></div>
          <p>OPERADOR</p>
        </div>
        <div style={firmaBox}>
          <div style={firmaLinea}></div>
          <p>V° B° JEFE OBRA</p>
        </div>
      </div>
    </div>
  );

  function getFaena(tipo) {
    return datos.faena?.find(f => f.tipo === tipo)?.cantidad || "";
  }
}

// === ESTILOS ===
const containerStyle = {
  width: "13.5cm",
  minHeight: "20cm",
  padding: "20px",
  border: "1px solid #000",
  backgroundColor: "#fff",
  fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  fontSize: "12px",
  color: "#222",
};

const encabezadoStyle = {
  display: "flex",
  gap: "20px",
  alignItems: "center",
  marginBottom: "15px",
};

const logoStyle = {
  width: "70px",
};

const infoEmpresaStyle = {
  flex: 1,
  lineHeight: "1.4",
};

const tituloEmpresa = {
  margin: 0,
  fontSize: "20px",
  fontWeight: "700",
  color: "#ff0000ff",
  textTransform: "uppercase",
  letterSpacing: "1px",
};

const textoSub = {
  margin: "3px 0",
  fontSize: "12px",
  color: "#555",
  fontStyle: "italic",
};

const textoNormal = {
  margin: "2px 0",
  fontSize: "12px",
};

const fechaCajaStyle = {
  display: "flex",
  justifyContent: "space-between",
  marginBottom: "10px",
  marginTop: "10px",
  border: "1px solid #000",
  padding: "5px",
  borderRadius: "5px",
};

const fechaBox = {
  flex: 1,
  textAlign: "center",
  fontWeight: "bold",
};

const camionPatenteStyle = {
  display: "flex",
  justifyContent: "space-between",
  marginBottom: "10px",
  fontWeight: "bold",
};

const campoCamion = {
  display: "flex",
  alignItems: "center",
  gap: "5px",
  flex: 1.5,
};

const lineaCamion = {
  borderBottom: "1px solid #000",
  minWidth: "265px",
  display: "inline-block",
  paddingBottom: "1px",
};

const lineaFaena = {
  borderBottom: "1px solid #000",
  minWidth: "80px",
  display: "inline-block",
  paddingBottom: "1px",
};

// 🟦 NUEVOS ESTILOS DE TABLA
const tableStyle = {
  width: "100%",
  borderCollapse: "separate",
  borderSpacing: 0,
  margin: "10px 0",
  borderRadius: "6px",
  overflow: "hidden",
  boxShadow: "0 0 0 1px #ccc",
};

const cellStyle = {
  border: "1px solid #ccc",
  padding: "6px 8px",
  textAlign: "center",
  fontSize: "11.5px",
};

const headerCellStyle = {
  ...cellStyle,
  backgroundColor: "#f2f2f2",
  fontWeight: "700",
  fontSize: "12px",
  color: "#111",
};


const actividadBoxStyle = {
  marginTop: "10px",
  marginBottom: "10px",
  paddingLeft: "10px",
};

const lineaActividad = {
  marginBottom: "4px",
};

const sectionTitleStyle = {
  fontWeight: "bold",
  marginTop: "10px",
  marginBottom: "5px",
  textTransform: "uppercase",
};

const lineaObservacion = {
  borderBottom: "1px solid #000",
  minHeight: "25px",
  padding: "5px 5px",
};

const firmasStyle = {
  display: "flex",
  justifyContent: "space-around",
  marginTop: "40px",
};

const firmaBox = {
  textAlign: "center",
};

const firmaLinea = {
  borderBottom: "1px solid #000",
  width: "180px",
  height: "30px",
  marginBottom: "5px",
};


const sectionTitleBox = {
  display: "flex",
  flexDirection: "column",
  gap: "2px",
  marginTop: "10px",
};

const lineaHorizontal = {
  borderBottom: "1px solid #000",
  width: "100%",
};

export default ReporteCamion;
